// Logo intro API (middleware `/api/logo-intro`): hand-written motion scene
// templates filled with the organization's logo and the course title.

import { authedFetch } from "../../../common/http_service";
import { _LoadMediaFile } from "../../../common/server_utils.es6";

const apiBase = () => `${process.env.MW_API_URL}api/logo-intro`;

async function readJson(response) {
  let body = null;
  try {
    body = await response.json();
  } catch {
    body = null;
  }
  if (!response.ok) {
    const message = (body && body.message) || `Request failed (${response.status})`;
    throw new Error(Array.isArray(message) ? message.join(", ") : message);
  }
  return body;
}

/**
 * `{ templates: [{ id, durationSec, name: { en, tr, es } }], fonts: [{ id, name }] }`
 * — the fonts are the ones the server can embed in a document, so the list
 * lives there rather than here.
 */
export async function listLogoIntroCatalog() {
  const body = await readJson(await authedFetch(`${apiBase()}/templates`));
  return { templates: (body && body.items) || [], fonts: (body && body.fonts) || [] };
}

/**
 * Fill a template. `preview: true` → `{ html, durationSec }` (nothing stored);
 * otherwise → `{ htmlUrl, durationSec, navId, boxId, box, toolbar }`.
 */
export async function renderLogoIntro(payload) {
  const res = await authedFetch(`${apiBase()}/render`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  return readJson(res);
}

/** Upload a freshly picked logo file into the training's media; resolves to its url. */
export function uploadLogoFile(file) {
  return new Promise((resolve, reject) => {
    const started = _LoadMediaFile(
      file,
      (name, mime, fileUrl) => (fileUrl ? resolve(fileUrl) : reject(new Error("upload-failed"))),
      null,
      (err) => reject(new Error((err && err.userMessage) || "upload-failed"))
    );
    if (started === false) reject(new Error("upload-failed"));
  });
}
